export default "__VITE_ASSET__WvG_8xdO__"